module.exports = __webpack_public_path__ + "assets/img/s2_tab1.81391f19.png";